export default "__VITE_ASSET__DVXuwPUs__"